<template>
    <div>
        <section id="global-contact-us" ref="contact" class="contact">
            <div class="container">
                <div class="contact-container">
                    <div class="contact-info">
                        <div class="section-title">
                            <h2>Contact Us</h2>
                            <p>Share your brief. We'll architect your entry</p>
                            <p>Reach our team:</p>
                        </div>
                        <div class="contact-details">
                            <p>Email: suntianlu@roadlinkglb.com</p>
                            <p>Phone: +852 95884096</p>
                            <p>Linkedin:&nbsp;&nbsp;<a href="https://www.linkedin.com/in/suntianlu/" class="white-link">suntianlu</a></p>
                        </div>

                        <div class="social-links">
                            <div class="social-icons">
                                <a href="https://www.instagram.com/roadlink.glb/">
                                    <img src="../assets/icon_ins.png" alt="Instagram" />
                                </a>
                                <a href="https://www.facebook.com/profile.php?id=61578082956882">
                                    <img src="../assets/icon_facebook.png" alt="Facebook" />
                                </a>
                                <a href="https://www.linkedin.com/company/roadlinkglb/">
                                    <img src="../assets/icon_in.jpg" alt="Linkedin" />
                                </a>
                                <a href="https://www.youtube.com/@RoadlinkGLB">
                                    <img src="../assets/icon_youtube.png" alt="Youtubo" />
                                </a>
                            </div>
                        </div>
                        <div class="footer-links">
                            <a href="/privacy-policy" class="footer-link">Privacy Policy</a>
                            <!-- <a href="/privacy-policy" class="footer-link">Disclaimer</a> -->
                        </div>
                    </div>

                    <div class="contact-form">
                        <h3>Contact us</h3>
                        <form @submit.prevent="submitForm">
                            <div class="form-group">
                                <input type="text" id="name" v-model="formData.name" placeholder="Please enter your Name/Company Name">
                                <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
                            </div>

                            <div class="form-group">
                                <input type="email" id="email" v-model="formData.email" placeholder="Please enter your Email">
                                <span class="error-message" v-if="errors.email">{{ errors.email }}</span>
                            </div>

                            <div class="form-group">
                                <input type="text" id="subject" v-model="formData.subject" placeholder="Please enter your Subject">
                                <span class="error-message" v-if="errors.subject">{{ errors.subject }}</span>
                            </div>

                            <div class="form-group">
                                <input type="text" id="destination" v-model="formData.destination" placeholder="Please enter your Destination">
                                <span class="error-message" v-if="errors.destination">{{ errors.destination }}</span>
                            </div>

                            <div class="form-group">
                                <textarea id="information" rows="4" v-model="formData.information"
                                    placeholder="Please enter your information, such as your products and objectives, etc"></textarea>
                                <span class="error-message" v-if="errors.information">{{ errors.information }}</span>
                            </div>

                            <button type="submit" class="btn-primary" :disabled="isSubmitting">
                                {{ isSubmitting ? 'SUBMITTING...' : 'SUBMIT' }}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        
        <!-- Toast提示组件 -->
        <div class="toast" :class="{ 'show': toast.show }">
            <div class="toast-content" :class="toast.type">
                <span class="toast-icon">
                    <i :class="toast.type === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'"></i>
                </span>
                <span class="toast-message">{{ toast.message }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactsUs',
    data() {
        return {
            formData: {
                name: '',
                email: '',
                subject: '',
                destination: '',
                information: ''
            },
            errors: {
                name: '',
                email: '',
                subject: '',
                destination: '',
                information: ''
            },
            isSubmitting: false,
            toast: {
                show: false,
                message: '',
                type: 'success' // 'success' or 'error'
            }
        };
    },
    methods: {
        // 验证邮箱格式
        validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        
        // 验证表单
        validateForm() {
            let isValid = true;
            
            // 重置错误信息
            this.errors = {
                name: '',
                email: '',
                subject: '',
                destination: '',
                information: ''
            };
            
            // 验证姓名
            if (!this.formData.name.trim()) {
                this.errors.name = 'Name is required';
                isValid = false;
            }
            
            // 验证邮箱
            if (!this.formData.email.trim()) {
                this.errors.email = 'Email is required';
                isValid = false;
            } else if (!this.validateEmail(this.formData.email)) {
                this.errors.email = 'Please enter a valid email address';
                isValid = false;
            }
            
            // 验证主题
            if (!this.formData.subject.trim()) {
                this.errors.subject = 'Subject is required';
                isValid = false;
            }
            
            // 验证目的地
            if (!this.formData.destination.trim()) {
                this.errors.destination = 'Destination is required';
                isValid = false;
            }
            
            // 验证信息
            if (!this.formData.information.trim()) {
                this.errors.information = 'Information is required';
                isValid = false;
            }
            
            return isValid;
        },
        
        // 显示Toast提示
        showToast(message, type = 'success') {
            this.toast.message = message;
            this.toast.type = type;
            this.toast.show = true;
            
            // 3秒后自动隐藏
            setTimeout(() => {
                this.toast.show = false;
            }, 3000);
        },
        
        // 提交表单
        async submitForm() {
            // 验证表单
            if (!this.validateForm()) {
                this.showToast('Please fill in all required fields correctly', 'error');
                return;
            }
            
            this.isSubmitting = true;
            
            try {
                // 使用代理发送请求到API
                const response = await fetch('/api/zjs/os/contact/submit', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(this.formData)
                });
                
                const result = await response.json();
                
                if (result.code === 0) {
                    // 提交成功
                    this.showToast('Submission successful. Our staff will contact you shortly.');
                    
                    // 重置表单
                    this.formData = {
                        name: '',
                        email: '',
                        subject: '',
                        destination: '',
                        information: ''
                    };
                } else {
                    // 提交失败，显示错误信息
                    this.showToast(result.msg || 'Submission failed, please try again later', 'error');
                }
            } catch (error) {
                console.error('Submission error:', error);
                this.showToast('Network error, please try again later', 'error');
            } finally {
                this.isSubmitting = false;
            }
        }
    }
};
</script>

<style scoped>
    /* 基础样式 */
    .container {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding: 0 20px;
        box-sizing: border-box;
    }

    /* Hero Section */
    .hero {
        background: url('../assets/home_banner.jpg');
        background-size: cover;
        background-position: center;
        color: white;
        padding: 100px 0;
        text-align: center;
    }

    .hero h1 {
        font-size: 36px;
        margin-bottom: 20px;
        line-height: 1.2;
    }

    .hero p {
        font-size: 16px;
        max-width: 700px;
        margin: 0 auto 27px;
        line-height: 1.5;
    }

    /* Stats Section */
    .stats {
        padding: 60px 0;
        background-color: #2444CB;
    }

    .stats-grid {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        gap: 30px;
    }

    /* Services Section */
    /* Services Section - 修复响应式布局 */
    .services {
        padding: 60px 0;
        background-color: white;
    }

    .services-wrapper {
        display: grid;
        grid-template-columns: 1.2fr 1fr;
        gap: 80px;
        align-items: center;
    }

    .services-content {
        display: flex;
        flex-direction: column;
    }

    .services-list {
        display: flex;
        flex-direction: column;
        gap: 25px;
        margin-top: 30px;
    }

    .service-item {
        display: flex;
        align-items: flex-start;
        gap: 20px;
    }

    .service-icon {
        width: 42px;
        height: 42px;
        border-radius: 100px;
        border: 2px solid #DDDDDD;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
    }

    .service-icon img {
        width: 20px;
        height: 20px;
    }

    .service-text {
        flex: 1;
    }

    .service-title {
        font-size: 26px;
        color: #222222;
        margin-bottom: 8px;
        font-weight: 600;
    }

    .service-desc {
        font-size: 16px;
        color: #222222;
        line-height: 1.5;
    }

    .details-button {
        width: 200px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #265FFF;
        border-radius: 8px;
        margin-top: 40px;
    }

    .details-link {
        font-size: 14px;
        color: white;
        text-decoration: none;
        font-weight: 500;
    }

    .services-image {
        width: 100%;
        height: auto;
        border-radius: 8px;
        overflow: hidden;
        /* box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1); */
        padding-top: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .services-image img {
        width: 100%;
        height: auto;
        object-fit: cover;
    }

    /* Diagnosis Section */
    .diagnosis {
        padding: 100px 0;
        background-color: #2444CB;
    }

    .diagnosis .section-title h2 {
        font-size: 44px;
        color: white;
    }

    .diagnosis .section-title p {
        font-size: 16px;
        color: white;
    }

    .title-decoration {
        height: 12px;
        width: 60px;
        background-color: #FF9E1B;
        margin-bottom: 16px;
    }

    .diagnosis-container {
        margin: 0 auto;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .diagnosis-form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 20px;
    }

    /* 下拉框样式调整 */
    .form-group {
        position: relative;
    }

    .form-group select {
        width: 100%;
        font-size: 16px;
        padding: 12px 16px;
        border: 1px solid #ddd;
        border-radius: 4px;
        box-sizing: border-box;
        /* 移除默认箭头并添加自定义样式 */
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: calc(100% - 12px) center;
        /* 向左移动20px */
        background-size: 16px;
        padding-right: 40px;
        /* 增加右侧内边距为箭头留空间 */
    }

    /* 单独设置联系表单的placeholder颜色 */
    .contact-form input::placeholder,
    .contact-form textarea::placeholder,
    .contact-form select:invalid {
        color:#999;
    }

    .contact-form select option[value=""] {
        color: black;
    }

    .form-buttons {
        grid-column: 1 / -1;
        display: flex;
        gap: 15px;
        margin-top: 20px;
    }

    .btn-primary {
        background-color: #FF9E1B;
        color: black;
        border: none;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        flex: 1;
    }

    .btn-secondary {
        background-color: transparent;
        color: white;
        border: 1px solid white;
        padding: 12px 24px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        flex: 1;
    }

    /* Analysis Section */
    .analysis-recommend {
        padding: 60px 0;
        background-color: white;
    }

    .analysis-recommend h3 {
        font-size: 32px;
        color: #222222;
        margin-bottom: 30px;
    }

    .analysis-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 30px;
        margin-top: 44px;
    }

    .analysis-item {
        border: 1px solid #2444CB;
        border-radius: 8px;
        padding: 10px 0px;
        background-color: white;
        display: flex;
        flex-direction: column;
    }

    .analysis-header {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        justify-content: center;
        /* height: 40px; */
        padding: 15px 20px;
    }

    .analysis-header img {
        height: 23px;
        width: 23px;
    }

    .analysis-header p {
        margin-left: 10px;
        font-family: Arial, Arial;
        font-weight: normal;
        font-size: 18px;
        color: #222222;
        line-height: 24px;
        font-style: normal;
        text-transform: none;
    }

    .divider {
        height: 1px;
        background-color: #2444CB;
        width: 100%;
        margin: 0 0;
    }

    .analysis-content {
        display: flex;
        flex-direction: column;
        padding: 25px;
        /* 增加内边距，使文字与边框距离增加 */
        font-size: 16px;
        flex: 1;
    }

    .content-label {
        color: #303030;
        margin-bottom: 12px;
        /* 增加标签与内容框之间的距离 */
    }

    .content-box {
        /* height: 50px; */
        display: flex;
        align-items: center;
        margin-bottom: 18px;
        /* 增加内容框之间的间距 */
    }

    .empty-text {
        color: #999999;
    }

    .filled-box {
        border: 2px solid #2444CB;
        border-radius: 6px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        font-size: 14px;
        padding: 10px 20px;

        height: auto; /* 不再填满父节点，让 padding 生效并扩高 */
        box-sizing: border-box;
        /* 为填充框内的文字增加内边距 */
    }

    .filled-box p {
        color: #2444CB;
        margin: 0;
    }

    .contact-link {
        display: flex;
        align-items: left;
        font-size: 14px;
        margin-top: 15px;
        /* 增加联系链接的顶部间距 */
    }

    .contact-link a {
        color: #265FFF;
        text-decoration: none;
    }

    .report-buttons {
        display: flex;
        flex-direction: column;
        width: 100%;
        gap: 15px;
        margin-top: 10px;
        padding: 10px 20px;
    }

    .btn-outline {
        background-color: white;
        border: 1px solid #265FFF;
        color: #265FFF;
        padding: 12px 24px;
        border-radius: 4px;
        font-family: PingFang-SC, PingFang-SC;
        font-weight: 800;
        font-size: 14px;
        font-style: normal;
        height: 40px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    /* Related Services */
    .related-services {
        padding: 60px 0;
        background-color: #2444CB;
        width: 100%;
    }

    .related-services .section-title h2 {
        font-size: 24px;
        color: white;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
    }

    .services-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
        gap: 30px;
        width: 100%;
    }

    .service-card {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .card-header {
        background-color: #265FFF;
        color: white;
        padding-left: 31px;
    }

    .card-header h3 {
        margin: 0;
        font-size: 24px;
        font-family: Arial, Arial;
        font-weight: normal;
        height: 60px;
        display: flex;
        align-items: center;
    }

    .card-content {
        padding: 20px 25px 0 31px;
    }

    .card-content ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .card-content li {
        margin-bottom: 12px;
        padding-left: 20px;
        position: relative;
        font-size: 16px;
        line-height: 1.4;
    }

    .card-content li:before {
        content: "•";
        color: #265FFF;
        font-weight: bold;
        position: absolute;
        left: 0;
    }

    /* Featured Documents */
    .featured-documents {
        padding: 60px 0;
        background-color: white;
    }

    .documents-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 30px;
    }

    .document-card {
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
    }

    .document-card:hover {
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    }

    .document-image {
        height: 200px;
        overflow: hidden;
    }

    .document-image img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    .document-summary {
        padding: 20px;
    }

    .document-summary p {
        margin-bottom: 10px;
        line-height: 1.5;
        font-size: 16px;
    }

    .document-date {
        color: #222222;
        font-size: 12px;
    }

    /* Success Stories */
    .success-stories {
        padding: 60px 0;
        background-color: #2444CB;
    }

    .success-stories .section-title h2 {
        color: white;
        font-size: 32px;
    }

    .stories-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
        gap: 30px;
    }

    .story-card {
        background-color: white;
        border-radius: 8px;
        overflow: hidden;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .story-content {
        display: flex;
        flex-direction: column;
        height: 220px;
        background: url('../assets/light_bg.png');
        background-size: cover;
        background-position: center;
        padding: 25px;
    }

    .story-content h3 {
        padding: 0;
        font-size: 20px;
        color: #222222;
        height: 60px;
        margin: 0;
        display: flex;
        align-items: center;
    }

    .story-description {
        height: 160px;
    }

    .story-description p {
        font-size: 18px;
        color: #222222;
        line-height: 1.4;
        margin: 0;
    }

    /* Contact Section */
    .contact {
        padding: 60px 0;
        /* 用户要求：联系模块背景改为浅灰色（与 Contact.vue 页面背景一致） */
        background-color: #f0f2f5;
    }

    .contact-container {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 50px;
    }

    .footer-links {
        display: flex;
        gap: 35px;
        margin-top: auto; /* 这将把链接推到容器底部 */
        padding-top: 30px;
    }

    .footer-link {
        color: #265FFF;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s ease;
    }

    .footer-link:hover {
        color: #1a3a5f;
    }

    /* 确保contact-info使用flex布局以支持底部对齐 */
    .contact-info {
        display: flex;
        flex-direction: column;
        height: 100%;
    }

    .contact-info .section-title h2 {
        font-size: 44px;
        color: #1a3a5f;
    }

    .contact-info .section-title p {
        color: #555;
        font-size: 16px;
        line-height: 1.5;
    }

    .contact-details {
        margin-top: 30px;
        color: #333;
    }

    .contact-details p {
        margin-bottom: 10px;
    }

    .social-links {
        margin-top: 30px;
    }

    .social-icons {
        display: flex;
        gap: 20px;
    }

    .social-icons a img {
        height: 31px;
        width: 31px;
    }

    .contact-form {
        background-color: white;
        padding: 30px;
        border-radius: 8px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
    }

    .contact-form h3 {
        color: #1a3a5f;
        margin-bottom: 20px;
        font-size: 24px;
    }

    .contact-form .form-group {
        margin-bottom: 20px;
        position: relative;
    }

    .contact-form input,
    .contact-form select,
    .contact-form textarea {
        width: 100%;
        padding: 12px 16px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 16px;
        box-sizing: border-box;
    }

    /* 为联系表单的下拉框也应用相同的样式 */
    .contact-form select {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
        background-repeat: no-repeat;
        background-position: calc(100% - 12px) center;
        background-size: 16px;
        padding-right: 40px;
    }

    .contact-form .btn-primary {
        background-color: #265FFF;
        width: 100%;
        color: white;
    }

    /* Report Modal */
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .report-modal {
        background-color: white;
        padding: 30px;
        border-radius: 8px;
        max-width: 600px;
        width: 90%;
        max-height: 80vh;
        overflow-y: auto;
    }

    .report-content {
        margin: 20px 0;
        line-height: 1.6;
    }
    
    /* 错误消息样式 */
    .error-message {
        color: #ff4757;
        font-size: 14px;
        display: block;
        margin-top: 5px;
    }
    
    /* Toast提示样式 */
    .toast {
        position: fixed;
        top: 20px;
        right: 20px;
        background: white;
        border-radius: 8px;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        padding: 16px 20px;
        min-width: 300px;
        max-width: 400px;
        z-index: 10000;
        transform: translateX(150%);
        transition: transform 0.3s ease;
        border-left: 4px solid #265FFF;
    }
    
    .toast.show {
        transform: translateX(0);
    }
    
    .toast-content {
        display: flex;
        align-items: center;
        gap: 12px;
    }
    
    .toast.success {
        border-left-color: #2ed573;
    }
    
    .toast.error {
        border-left-color: #ff4757;
    }
    
    .toast-icon {
        font-size: 20px;
    }
    
    .toast.success .toast-icon {
        color: #2ed573;
    }
    
    .toast.error .toast-icon {
        color: #ff4757;
    }
    
    .toast-message {
        font-size: 14px;
        line-height: 1.4;
        color: #333;
    }
    
    /* 禁用按钮样式 */
    .btn-primary:disabled {
        background-color: #cccccc;
        cursor: not-allowed;
        opacity: 0.7;
    }
    
    /* 输入框错误状态 */
    .form-group input:invalid,
    .form-group textarea:invalid {
        border-color: #ff4757;
    }
    
    .form-group input:focus:invalid,
    .form-group textarea:focus:invalid {
        border-color: #ff4757;
        box-shadow: 0 0 0 2px rgba(255, 71, 87, 0.2);
    }

    /* 响应式设计 */
    @media (max-width: 1200px) {
        .container {
            padding: 0 40px;
        }

        .stats-grid {
            grid-template-columns: repeat(2, 1fr);
            /* 中等屏幕显示2列 */
        }

        .services-wrapper {
            gap: 60px;
        }

        .service-title {
            font-size: 24px;
        }
    }

    @media (max-width: 992px) {
        .contact-container {
            grid-template-columns: 1fr;
            gap: 30px;
        }

        .diagnosis-form {
            grid-template-columns: 1fr;
        }

        .services-wrapper {
            grid-template-columns: 1fr;
            gap: 50px;
        }

        .services-image {
            order: -1;
            /* 图片在上方 */
            max-width: 500px;
            margin: 0 auto;
        }

        .services-content {
            text-align: center;
        }

        .service-item {
            justify-content: center;
            text-align: left;
        }

        .details-button {
            margin: 40px auto 0;
        }
    }

    @media (max-width: 768px) {
        .container {
            padding: 0 20px;
        }

        .hero {
            padding: 40px 0;
        }

        .hero h1 {
            font-size: 28px;
        }

        .hero p {
            font-size: 14px;
        }

        .stats,
        .diagnosis,
        .analysis-recommend,
        .related-services,
        .featured-documents,
        .success-stories,
        .contact {
            padding: 40px 0;
        }

        .stats-grid {
            grid-template-columns: 1fr;
            /* 小屏幕显示1列 */
            gap: 20px;
        }

        .section-title h2 {
            font-size: 24px;
        }

        .diagnosis .section-title h2 {
            font-size: 32px;
        }

        .contact-info .section-title h2 {
            font-size: 32px;
        }

        .services {
            padding: 40px 0;
        }

        .services-wrapper {
            gap: 40px;
        }

        .services-list {
            gap: 20px;
            margin-top: 25px;
        }

        .service-item {
            flex-direction: column;
            align-items: center;
            text-align: center;
            gap: 15px;
        }

        .service-title {
            font-size: 22px;
        }

        .service-desc {
            font-size: 15px;
        }

        .services-image {
            max-width: 100%;
            height: 370px;
        }

        .analysis-grid {
            grid-template-columns: 1fr;
            gap: 20px;
        }

        .documents-grid {
            grid-template-columns: 1fr;
        }

        .stories-grid {
            grid-template-columns: 1fr;
        }

        .form-buttons {
            flex-direction: column;
        }

        .report-buttons {
            padding: 0 15px;
        }

        .contact-form {
            padding: 20px;
        }
    }

    @media (max-width: 576px) {
        .services-wrapper {
            gap: 30px;
        }

        .service-title {
            font-size: 20px;
        }

        .service-desc {
            font-size: 14px;
        }

        .service-icon {
            width: 38px;
            height: 38px;
        }

        .service-icon img {
            width: 18px;
            height: 18px;
        }

        .details-button {
            width: 100%;
            max-width: 200px;
        }

        .services-image {
            height: 320px;
        }
    }

    @media (max-width: 480px) {
        .hero h1 {
            font-size: 24px;
        }

        .service-title {
            font-size: 18px;
        }

        .service-desc {
            font-size: 14px;
        }

        .services-list {
            gap: 25px;
        }

        .service-item {
            gap: 12px;
        }

        .diagnosis .section-title h2 {
            font-size: 28px;
        }

        .contact-info .section-title h2 {
            font-size: 28px;
        }

        .social-icons {
            justify-content: center;
        }

        .details-button {
            width: 100%;
            max-width: 200px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    /* 定义链接样式（浅灰背景下的深色链接） */
    .white-link {
        color: #265FFF;
        text-decoration: none; /* 去除下划线（可选） */
    }

    /*  hover 状态（可选，鼠标悬浮时样式） */
    .white-link:hover {
        color: #1a3a5f; /* 深蓝（hover 时略微变深，提升交互体验） */
        text-decoration: underline; /*  hover 时显示下划线（可选） */
    }
</style>